import { render, staticRenderFns } from "./ReceiptStage3.vue?vue&type=template&id=a2fcb202&scoped=true&"
import script from "./ReceiptStage3.vue?vue&type=script&lang=js&"
export * from "./ReceiptStage3.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptStage3.vue?vue&type=style&index=0&id=a2fcb202&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fcb202",
  null
  
)

export default component.exports